import '../assets/NcCheckboxRadioSwitch-BkBep4wT.css';
import { r as register } from "./_l10n-em5EAi4q.mjs";
register();
